module.exports = __webpack_public_path__ + "static/media/283.5881dc6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/283.jpg
// module id = 972
// module chunks = 0